import {fetchDelete, fetchGet, fetchPatch, fetchPost} from "./util";

export const getInvoices = ({results, columns, offset, filter, sort}) => {
    return fetchGet(`/invoices?results=${results}&columns=${columns}&offset=${offset}${filter}${sort}`).then(res => res);
}
export const deleteInvoice = (invoice_id) => {
    return fetchDelete(`/invoices/${invoice_id}`).then(res => res);
}
export const getLayouts = () => {
    return fetchGet(`/invoice-layouts`).then(res => res);
}
export const getProducts = () => {
    return fetchGet(`/invoice-products`).then(res => res);
}
export const getPaymentTerms = () => {
    return fetchGet(`/invoice-payment-terms`).then(res => res);
}

export const getEconomicResaleProducts = () => {
    return fetchGet(`/economic-resale-products`).then(res => res);
}

export const saveInvoice = (invoiceId, data) => {
    return fetchPatch(`/invoices/${invoiceId}`, data).then(res => res);
}

export const draftInvoice = (invoiceId, data) => {
    return fetchPost(`/invoices/${invoiceId}/draft`, data).then(res => res);
}